var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import moment from 'moment';
import { SingleDatePickerStatelessDEPRECATED as SingleDatePicker } from '@ally/metronome-ui';
import usePrevious from '@ally/use-previous';
import { mergeRefs, useRegisterError } from '../utils';
const getIsCorrectFormat = (dateString) => {
    return moment(dateString, 'MM/DD/YYYY', true).isValid();
};
const FormSingleDatePicker = (_a) => {
    var { name, validate, onDateChange, initializeDate, onFocusHandler, onBlur } = _a, props = __rest(_a, ["name", "validate", "onDateChange", "initializeDate", "onFocusHandler", "onBlur"]);
    const [field, meta, helpers] = useField({
        name,
        validate,
    });
    const { refValue } = useRegisterError(meta.error);
    const inputRef = useRef(null);
    const ref = refValue ? mergeRefs([refValue, inputRef]) : inputRef;
    useEffect(() => {
        if (initializeDate) {
            helpers.setValue(initializeDate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const errorMessage = meta.touched ? meta.error : '';
    const combinedOnDateChange = (value) => {
        if (onDateChange) {
            onDateChange(value);
        }
    };
    const handleOnChange = (dateString) => {
        helpers.setValue(dateString);
    };
    const safeDate = getIsCorrectFormat(field.value) ? moment(field.value) : null;
    // Trigger Formik onBlur handler for validations
    // The onFocusHandler from the DatePicker seems to be heavily tied to wether the calendar
    // picker is open so here we listen to focus changes from the text input as well
    const [calendarFocus, setCalendarFocus] = useState(null);
    const [inputFocus, setInputFocus] = useState(false);
    const focus = !!calendarFocus || inputFocus;
    const prevFocus = usePrevious(focus);
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (inputRef.current) {
            const focusHandler = () => setInputFocus(true);
            const blurHandler = () => setInputFocus(false);
            inputRef.current.addEventListener('focus', focusHandler);
            inputRef.current.addEventListener('blur', blurHandler);
            return () => {
                var _a, _b;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', focusHandler);
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('blur', blurHandler);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputRef.current]);
    const combinedOnFocusHandler = (value) => {
        setCalendarFocus(value);
        if (onFocusHandler) {
            onFocusHandler(value);
        }
    };
    const combinedOnBlur = (e) => {
        field.onBlur(e);
        if (onBlur)
            onBlur(e);
    };
    useEffect(() => {
        if (prevFocus === true && focus !== true)
            combinedOnBlur({
                target: { name },
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focus]);
    return (React.createElement(SingleDatePicker, Object.assign({ onDateChange: combinedOnDateChange, errorMessage: errorMessage, onChange: handleOnChange, onFocusHandler: combinedOnFocusHandler, ref: ref, id: name, date: safeDate }, props)));
};
export default FormSingleDatePicker;
//# sourceMappingURL=SingleDatePicker.js.map